import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { getPackageDetail, getPackageType, updatePackageData, getAuthorSuggest } from '../../API/FetchCall';

import Autosuggest from 'react-autosuggest';

import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import SimpleReactValidator from 'simple-react-validator';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class editPackage extends Component {

    constructor(props) {
        super(props);
        this.state = {
          logged: localStorage.getItem("authentication"),
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          write_permission: true,
          package_id: 0,
          plan_name: '',
          our_offers: '<ul><li>Edit Here</li></ul>',
          our_offers_soon: '<ul><li>Edit Here</li></ul>',
          analytics_offers: '<ul><li>Edit Here</li></ul>',
          analytics_offers_soon: '<ul><li>Edit Here</li></ul>',
          base_price: '',
          discount_percent: '',
          offer_name: '',
          discount_amount: '',
          plan_price: '',
          about_words: '',
          image_counts: '',
          new_icon: '',
          current_icon: '',
          head_bottom_color: '',
          plan_type: '',
          plan_type_list: [],
          restriction: {},
          btnValue: 'Update Package'
        };
        this.id = this.props.match.params.id ? this.props.match.params.id : '';
        this.validator = new SimpleReactValidator();
        this.package_detail = this.package_detail.bind(this);
        this.getpackageTypeList = this.getpackageTypeList.bind(this);
    }


  componentDidMount() {

    var THIS = this;
    
    this.package_detail(this.id);
    this.getpackageTypeList();
  }


  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh')
  }

  getpackageTypeList() {
    getPackageType(JSON.stringify({ role: 1 })).then(res => {
      if (res.status === 1) {
        this.setState({
          plan_type_list: res.list
        })
      }
    });
  }  


  handleCustomeChange = (e) => {
    const propName = e.target.name;
    const files = e.target.value;
    let restriction = this.state.restriction;
    restriction[propName] = files;
    this.setState({
      restriction
    });
  };
  
  package_detail = (package_id) => {
    const { login_id, role } = this.state.auth_data;
    let ins = JSON.stringify({
      vendor_id: login_id,
      role: role,
      path: '/package_list',
      package_id: package_id,
    });
    getPackageDetail(ins).then((res) => {
      if (res.status == 1) {
        let data = res.details;
        this.setState({
          package_id: data.id,
          plan_name: data.plan_name,
          our_offers: data.plan_offer,
          our_offers_soon: data.plan_soon,
          analytics_offers: data.analytics_offer,
          analytics_offers_soon: data.analytics_soon,
          base_price: data.base_price,
          discount_percent: data.discount_percent,
          offer_name: data.offer_name,
          discount_amount: data.discount_amount,
          plan_price: data.plan_price,
          about_words: data.about_words_count,
          image_counts: data.image_count,
          current_icon: data.icon ? res.base_url + data.icon : '',
          head_bottom_color: data.icon_color,
          restriction: data.restriction ? JSON.parse(data.restriction) : {},
          plan_type: data.plan_type,
          write_permission: res.write_permission
        });
        this.updatePrice(data.base_price, data.discount_percent, data.discount_amount, data.plan_price);
      } else {
        window.location.href = '/package_list';
      }

    });
  }

  handleEditorChangeoffer(value, editor) {
    this.setState({
      our_offers: value
    });
  }
  handleEditorChangeofferSoon(value, editor) {
    this.setState({
      our_offers_soon: value
    });
  }
  handleEditorChangeanalytics(value, editor) {
    this.setState({
      analytics_offers: value
    });
  }
  handleEditorChangeanalyticsSoon(value, editor) {
    this.setState({
      analytics_offers_soon: value
    });
  }

 handleEditorChange(value, editor) {
    console.log(value);
    this.setState({
      insight_content: value
    });
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleCheck = (e) => {
    this.setState((prevState) => ({
      show_upload: !prevState.show_upload,
    }));
  };
  customChange = (e, i) => {
    let social_links = this.state.social_links;
    if (social_links.length > 0 && social_links[i]) {
      social_links[i].link = e.target.value;
    }
    this.setState({ social_links });
  };
  handleFile = (e) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({
      [propName]: files
    });
  };
  handleFileMultiple = (e) => {
    const propName = e.target.name;
    var files = e.target.files;
    if (files.length > 2) {
      files = '';
      let toastr = window.toastr.error; //warning
      toastr('', 'Select Article 2 Images Only', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
    }
    this.setState({
      [propName]: files
    });
  };
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  }

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  onSuggestionsFetchRequested = ({ value }) => {
    console.log('came first ', value);
    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      keyword: val,
      role: 1
    });
    getAuthorSuggest(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.list
        });
      }
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }
  onChange = (event, { newValue, method }) => {
    this.setState({
      insight_author: newValue
    });
  };

  render() {

        const { restriction } = this.state;
        console.log(restriction);
        this.validator.purgeFields();

        return (
            <React.Fragment>
                <AdminLayout>
                    
             <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Package - Edit</h4>
                    
                    <form onSubmit={this.handleSubmit} id='package_form'>
                    <div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Package Type <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">

                          <select className='form-control selectpicker' name='plan_type'
                            value={this.state.plan_type}
                            onChange={this.handleChange}
                            title='Select'>
                            {this.state.plan_type_list.map((item, i) => {
                              return (
                                <option value={item.id}>{item.name}</option>
                              )
                            })}
                          </select>
                          {this.validator.message('Package Type', this.state.plan_type, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Package Name <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='plan_name' className='form-control' type='text' value={this.state.plan_name}
                            onChange={this.handleChange} />
                          {this.validator.message('Package Name', this.state.plan_name, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Package Color <small>(Name of the color or code)</small> <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='head_bottom_color'
                            className='form-control'
                            placeholder='Ex: Black or #000'
                            type='text' value={this.state.head_bottom_color}
                            onChange={this.handleChange} />
                          {this.validator.message('Package Color', this.state.head_bottom_color, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Base Price <small>(INR)</small> <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='base_price'
                            className='form-control'
                            placeholder='0'
                            step='0.01' min='0' type='number'
                            value={this.state.base_price}
                            onChange={this.handleChange} />
                          {this.validator.message('Base Price', this.state.base_price, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Offer Name<span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='discount_percent'
                            className='form-control' type='text'
                            value={this.state.offer_name}
                            onChange={this.handleChange} />
                          {this.validator.message('Offer Name', this.state.offer_name, '', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Discount <small>(%)</small> <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='discount_percent'
                            className='form-control'
                            placeholder='0'
                            step='0.01' min='0' max='100' type='number'
                            value={this.state.discount_percent}
                            onChange={this.handleChange} />
                          {this.validator.message('Discount', this.state.discount_percent, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Discount <small>(INR)</small> <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='discount_amount'
                            className='form-control'
                            placeholder='0'
                            step='0.01'  min='0' type='number'
                            value={this.state.discount_amount}
                            onChange={this.handleChange} />
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Plan Price <small>(INR)</small> <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='plan_price'
                            className='form-control'
                            placeholder='0'
                            step='0.01'  min='0' type='number'
                            value={this.state.plan_price}
                            onChange={this.handleChange} />
                        </div>
                      </div>
                      {this.state.current_icon && (
                        <div className="row" style={{ marginBottom: '30px' }}>
                          <div class="form-group col-md-3">
                            <label>Current Plan Icon <span className="astrick">*</span></label>
                          </div>
                          <div class="form-group col-md-9">
                            <img src={this.state.current_icon} alt='banner' width='100px' height='100px' />
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Plan Icon <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input
                            type="file"
                            name="new_icon"
                            onChange={this.handleFile}
                            className="form-control mar-btm"
                            accept="image/x-png,image/gif,image/jpeg,image/svg"
                          />
                          {!this.state.current_icon && this.validator.message('Icon', this.state.new_icon, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: '30px' }}>
                        <div class="form-group col-md-3">
                          <label> Our Offers <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                         
                          <Editor
                          onEditorChange={this.handleEditorChangeoffer}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          
                          />

                          {this.validator.message('Our Offers', this.state.our_offers, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: '30px' }}>
                        <div class="form-group col-md-3">
                          <label> Our Offers Soon<span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <Editor
                          onEditorChange={this.handleEditorChangeofferSoon}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          
                          />
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: '30px' }}>
                        <div class="form-group col-md-3">
                          <label>Analytics Offer<span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          
                          <Editor
                          onEditorChange={this.handleEditorChangeanalytics}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          
                          />

                          {this.validator.message('Analytics Offer', this.state.analytics_offers, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: '30px' }}>
                        <div class="form-group col-md-3">
                          <label>Analytics Offer Soon<span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">


                          <Editor
                            onEditorChange={this.handleEditorChangeanalyticsSoon}
                            value={this.state.analytics_offers_soon}
               
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-12">
                          <h4>Restrictions</h4>
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Allowed Image Counts <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-3">
                          <input name='image_counts'
                            className='form-control'
                            step='1' min='0' type='number'
                            value={this.state.image_counts}
                            onChange={this.handleChange} />
                          {this.validator.message('Image Counts', this.state.image_counts, 'required', { className: 'text-danger' })}
                        </div>
                        <div class="form-group col-md-3">
                          <label> Allowed Words Counts <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-3">
                          <input name='about_words'
                            className='form-control'
                            step='1' min='0' type='number'
                            value={this.state.about_words}
                            onChange={this.handleChange} />
                          {this.validator.message('Words Counts', this.state.about_words, 'required', { className: 'text-danger' })}
                        </div>
                        <div class="form-group col-md-3">
                          <label> Allowed Articles Counts/ Year <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-3">
                          <input name='art_count'
                            className='form-control'
                            step='1' min='0' type='number'
                            value={restriction.art_count}
                            onChange={this.handleCustomeChange} />
                          {this.validator.message('Article', restriction.art_count, 'required', { className: 'text-danger' })}
                        </div>
                        <div class="form-group col-md-3">
                          <label> Download Reports <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-3">
                          <input type='radio' className='' name='download_report' onChange={this.handleCustomeChange} value={true}
                            checked={restriction.download_report == 'true'} /> Yes &nbsp;
                          <input type='radio' className='' name='download_report' onChange={this.handleCustomeChange} value={false}
                            checked={restriction.download_report == 'false'} /> No
                          {this.validator.message('Download Reports', restriction.download_report, 'required', { className: 'text-danger' })}
                        </div>
                        <div class="form-group col-md-3">
                          <label> Banner Space <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-3">
                          <input type='radio' className='' name='banner_space' onChange={this.handleCustomeChange} value={true}
                            checked={restriction.banner_space == 'true'} /> Yes &nbsp;
                          <input type='radio' className='' name='banner_space' onChange={this.handleCustomeChange} value={false}
                            checked={restriction.banner_space == 'false'} /> No
                          {this.validator.message('Banner Space', restriction.banner_space, 'required', { className: 'text-danger' })}
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-12">
                          <table className='table table-brodered'>
                            <tbody>

                            <tr>
                                <th>Leads</th>
                                <td>
                                  <input type='radio' className='' name='rep_leads' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_leads == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_leads' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_leads == 'false'} /> No
                                  {this.validator.message('Leads', restriction.rep_leads, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>

                              <tr>
                                <th>WiseConnect (Post a job and Talent Search)</th>
                                <td>
                                  <input type='radio' className='' name='rep_wiseconnect' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_wiseconnect == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_wiseconnect' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_wiseconnect == 'false'} /> No
                                  {this.validator.message('WiseConnect', restriction.rep_wiseconnect, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>


                              <tr>
                                <th>User Ratings and Trends</th>
                                <td>
                                  <input type='radio' className='' name='rep_rating_trending' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_rating_trending == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_rating_trending' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_rating_trending == 'false'} /> No
                                  {this.validator.message('User Ratings and Trends', restriction.rep_rating_trending, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>Number of visitors and unique visitors</th>
                                <td>
                                  <input type='radio' className='' name='rep_visitor' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_visitor == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_visitor' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_visitor == 'false'} /> No
                                  {this.validator.message('Image Counts', restriction.rep_visitor, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>Number of users who have liked and following</th>
                                <td>
                                  <input type='radio' className='' name='rep_likeflw' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_likeflw == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_likeflw' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_likeflw == 'false'} /> No
                                  {this.validator.message('Image Counts', restriction.rep_likeflw, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>User locations visiting</th>
                                <td>
                                  <input type='radio' className='' name='rep_location' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_location == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_location' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_location == 'false'} /> No
                                  {this.validator.message('User locations visiting', restriction.rep_location, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>Overall customer rating vs Average rating of other service providers​</th>
                                <td>
                                  <input type='radio' className='' name='rep_rating' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_rating == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_rating' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_rating == 'false'} /> No
                                  {this.validator.message('Rating', restriction.rep_rating, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>Variance in Registered vs Non-Registered Users</th>
                                <td>
                                  <input type='radio' className='' name='rep_user' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_user == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_user' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_user == 'false'} /> No
                                  {this.validator.message('Variance User', restriction.rep_user, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>Number of users - Wishlist</th>
                                <td>
                                  <input type='radio' className='' name='rep_wishlist' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_wishlist == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_wishlist' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_wishlist == 'false'} /> No
                                  {this.validator.message('Wishlist', restriction.rep_wishlist, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>Number of users - Viewed Video uploaded</th>
                                <td>
                                  <input type='radio' className='' name='rep_video_view' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_video_view == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_video_view' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_video_view == 'false'} /> No
                                  {this.validator.message('Viewed Video uploaded', restriction.rep_video_view, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                              <tr>
                                <th>Number of users - Viewed Article published</th>
                                <td>
                                  <input type='radio' className='' name='rep_view_art' onChange={this.handleCustomeChange} value={true}
                                    checked={restriction.rep_view_art == 'true'} /> Yes &nbsp;
                                  <input type='radio' className='' name='rep_view_art' onChange={this.handleCustomeChange} value={false}
                                    checked={restriction.rep_view_art == 'false'} /> No
                                  {this.validator.message('Viewed Article published', restriction.rep_view_art, 'required', { className: 'text-danger' })}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                       
                      <div className="row mb-4">
                        <button type='submit' id="btnSubmit"
                          className="btn btn-primary btn-sm" style={{ display: "block", margin: "auto" }}>
                          {this.state.btnValue}
                        </button>
                      </div>
                      
                    </div>
                  </form>
                 

                </div>
              </div>
            </div>  

            <NotificationContainer/>                        
                </AdminLayout>
            </React.Fragment>
        )
    }



  handleSubmit = (e) => {
    this.setState({
      btnValue: 'Please Wait...'
    })
    e.preventDefault();
    if (this.validator.allValid()) {
      let toastr = '';
      let insert = {
        package_id: this.state.package_id,
        plan_name: this.state.plan_name,
        our_offers: this.state.our_offers,
        our_offers_soon: this.state.our_offers_soon,
        analytics_offers: this.state.analytics_offers,
        analytics_offers_soon: this.state.analytics_offers_soon,
        base_price: this.state.base_price,
        discount_percent: this.state.discount_percent,
        offer_name: this.state.offer_name,
        discount_amount: this.state.discount_amount,
        plan_price: this.state.plan_price,
        about_words: this.state.about_words,
        image_counts: this.state.image_counts,
        new_icon: this.state.new_icon,
        head_bottom_color: this.state.head_bottom_color,
        plan_type: this.state.plan_type,
        restriction: JSON.stringify(this.state.restriction),
      }
      updatePackageData(insert).then((response) => {
        if (response.status == 1) {
           Notification.success(response.message);
          setTimeout(function () {
            window.location.href = '/package_list';
          }, 1000);
        } else {
          this.setState({
            btnValue: 'Update Package'
          })
          Notification.error(response.message);
          setTimeout(function () {
          }, 1000);
        }
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
}


export default editPackage;


// WEBPACK FOOTER //
// ./src/components/bewise/editPackage.jsx